import React from "react";
import { Flex, Tag, TagLabel, TagLeftIcon, useColorModeValue } from "@chakra-ui/react";
import { MdCheckCircle, MdError, MdWarning } from "react-icons/md";

/**
 * Renders summary tags showing missing, success, and error counts for QR code operations.
 * @param {object} props
 * @param {number} [props.totalMissing] - Number of missing QR codes (shown only if defined)
 * @param {number} props.totalSuccess - Number of successfully generated or dispatched codes
 * @param {string} props.successLabel - Label for the success tag
 * @param {number} props.totalErrors - Number of errors encountered
 * @returns {React.ReactElement}
 */
function QRCodeResultSummary({ totalMissing, totalSuccess, successLabel, totalErrors }) {
    const borderColor = useColorModeValue("gray.200", "whiteAlpha.300");
    return (
        <Flex gap="10px" flexWrap="wrap" pb="14px" mb="14px" borderBottom="1px solid" borderColor={borderColor}>
            {totalMissing !== undefined && (
                <Tag colorScheme="orange" borderRadius="full"><TagLeftIcon as={MdWarning} /><TagLabel>Missing: {totalMissing}</TagLabel></Tag>
            )}
            <Tag colorScheme="green" borderRadius="full"><TagLeftIcon as={MdCheckCircle} /><TagLabel>{successLabel}: {totalSuccess}</TagLabel></Tag>
            {totalErrors > 0 && (
                <Tag colorScheme="red" borderRadius="full"><TagLeftIcon as={MdError} /><TagLabel>Errors: {totalErrors}</TagLabel></Tag>
            )}
        </Flex>
    );
}

export default QRCodeResultSummary;
